const baseUrl=`https://ukezhavamatrimony.com`;
// const baseUrl = "http://localhost:18000";
export default baseUrl;
